module.exports = __webpack_public_path__ + "static/media/logoBaru.5108cb30.png";